import { list } from '../../../../../../common/classes/request-builder';
import type {
    DropdownData,
} from '@fitogest/reactive-form-builder/interfaces';
import type { ClienteModel } from '../../../../../../models/cliente.model';
import type { FincasModel } from '../../../../../../models/form-common/fincas.module';
import type { MantenimientoModel } from '../../../../../../models/trabajadores/mantenimiento.model';
import type { VisitasVariedadMesModel } from '../../../../../../models/visitas_variedad_mes/visitas_variedad_mes.model';

export class TareasPlantacionListsDefinition {
    public fincas: DropdownData<FincasModel> = list<FincasModel>();
    public clientes: DropdownData<ClienteModel> = list<ClienteModel>();
    public trabajadores: DropdownData<MantenimientoModel> = list<MantenimientoModel>();
    public cultivos: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>(['...', null]);
    public variedades: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>(['...', null]);
    public prioridades: DropdownData<string> = list<string>(['...', null], 'Alta', 'Realizada');
}
